import { formatDateTime } from 'utils/dates/date.utils';

export const getCurrentCondition = (currentConditions = []) => {
  return currentConditions?.[0] ?? null;
};

export const getCurrentConditionTitle = (currentCondition) => {
  return formatDateTime(currentCondition?.iso8601, 'short', 'Current Conditions');
};

export const hasSunData = (astronomy) => {
  return Boolean(astronomy?.sunrise && astronomy?.sunset);
}

export const hasMoonData = (astronomy) => {
  return Boolean(astronomy?.moonrise && astronomy?.moonset);
}
